import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

import App from './App.vue'
import About from './components/About'
import Players from './components/Players'
import Home from './components/Home'
import Results from './components/Results'
import Stats from './components/Stats'
import Venues from './components/Venues'
import Boxscore from './components/Boxscore'


const routes = [
  { path: '/about', component: About },
  { path: '/players', component: Players },
  { path: '/results', component: Results },
  { path: '/boxscore/:id', component: Boxscore },
  { path: '/stats', component: Stats },
  { path: '/venues', component: Venues },
  { path: '/', component: Home, props: true }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js